import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';

export interface ImageUniDriver extends BaseUniDriver {
  isTransparent: () => Promise<boolean>;
}
